import { ExternalLink, Zap } from 'lucide-react';
import LangEnum from '../../../lang/LangEnum';
import HASH_FLAGS from '../../../routes/hashFlags.const';
import { F, MenuFeatureKey } from '../../permissions/types/features.keys';
import { RoleBehaviorCapability } from '../../users/ability.types';
import { SearchableEntityType } from '../globalSearch.types';
import { resolveEntityListRoute } from '../lib/resolveRoute';
import { StaticCommandDefinition } from './staticCommands.types';

type ShortcutEntityType = Extract<SearchableEntityType, 'order' | 'catalog' | 'customer'>;

interface BuildShortcutParams {
  entityType: ShortcutEntityType;
  labelKey: LangEnum;
  menuFeature: MenuFeatureKey;
  aliases?: string[];
}

const buildShortcutCommand = ({
  entityType,
  labelKey,
  menuFeature,
  aliases,
}: BuildShortcutParams): StaticCommandDefinition => ({
  id: `shortcut-${entityType}`,
  type: 'shortcut',
  labelKey,
  icon: ExternalLink,
  aliases,
  canAccess: ({ isMenuVisible }) => isMenuVisible(menuFeature),
  run: ({ navigate, isStore }) =>
    navigate(resolveEntityListRoute({ entityType, term: '', isStore })),
});

export const STATIC_COMMANDS: StaticCommandDefinition[] = [
  {
    id: 'action-create-order',
    type: 'action',
    labelKey: LangEnum.GLOBAL_SEARCH_ACTION_CREATE_ORDER,
    icon: Zap,
    aliases: ['novo pedido'],
    canAccess: ({ ability, isStore }) => !isStore && ability.can('create', 'orders'),
    run: ({ openOrderBook }) => openOrderBook(),
  },
  {
    id: 'action-create-catalog',
    type: 'action',
    labelKey: LangEnum.GLOBAL_SEARCH_ACTION_CREATE_CATALOG,
    icon: Zap,
    aliases: ['coleção'],
    canAccess: ({ ability }) =>
      ability.hasCapability(RoleBehaviorCapability.CATALOGS_MANAGE_BRAND_CATALOGS),
    run: ({ navigate }) => navigate(`/catalogs#${HASH_FLAGS.createCatalog}`),
  },
  {
    id: 'action-create-customer',
    type: 'action',
    labelKey: LangEnum.GLOBAL_SEARCH_ACTION_CREATE_CUSTOMER,
    icon: Zap,
    canAccess: ({ ability, isMenuVisible }) =>
      isMenuVisible(F.menu.customers) && ability.can('create', 'customers'),
    run: ({ navigate }) => navigate('/customers?openCreate=1'),
  },
  buildShortcutCommand({
    entityType: 'order',
    labelKey: LangEnum.GLOBAL_SEARCH_SHORTCUT_ORDERS,
    menuFeature: F.menu.orders,
    aliases: ['abrir pedidos'],
  }),
  buildShortcutCommand({
    entityType: 'catalog',
    labelKey: LangEnum.GLOBAL_SEARCH_SHORTCUT_CATALOGS,
    menuFeature: F.menu.catalogs,
    aliases: ['coleção'],
  }),
  buildShortcutCommand({
    entityType: 'customer',
    labelKey: LangEnum.GLOBAL_SEARCH_SHORTCUT_CUSTOMERS,
    menuFeature: F.menu.customers,
    aliases: ['lojista'],
  }),
];
